import { isReactDevelopment } from '../constants'

const Config = {
  apiBaseUrl: isReactDevelopment ? 'https://tvprogram.eco-dev.cz/api' : '/api',
  domain: 'https://tvprogram.eco-dev.cz'
} as const

export default Config
